// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__YIL71{
    align-items: center;
    display: flex;
    justify-content: center;
}

.styles_paper__yWydt{
    background: white;
    border-radius: 10px;
    height: 80vh;
    width: 97vw;
}`, "",{"version":3,"sources":["webpack://./src/pages/AssinaturaContrato/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf","sourcesContent":[".container{\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\n.paper{\n    background: white;\n    border-radius: 10px;\n    height: 80vh;\n    width: 97vw;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__YIL71`,
	"paper": `styles_paper__yWydt`
};
export default ___CSS_LOADER_EXPORT___;
